import { reduce } from "et3-type-guards";
import React from "react";
import Stack from "@mui/material/Stack";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import { useLocation } from "react-router-dom";
import i18n from "../../../constants/i18n";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getUserAdvancedStore from "../../../stores/user-store/advanced-store";
import KhattabatUserAdvancedForm from "./user-advanced-form/KhattabatUserAdvancedForm";
import KhattabatUserAdvancedData from "./user-advanced-data/KhattabatUserAdvancedData";
import ET3PageDiv from "../../../core/et3-page-div";

const UserAdvanced = withLiteObserverAndTheme((props) => {
  const { unitX } = props.theme;
  const location = useLocation();
  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName("USER_ADVANCED", "USER_ADVANCED");
    getUserAdvancedStore().checkURLSearch(search);
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("ADVANCED_MODE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Stack
        spacing={3}
        sx={{ alignSelf: "stretch", pb: 2, pr: `${40 * unitX}px` }}
      >
        <KhattabatUserAdvancedForm />
        <KhattabatUserAdvancedData />
      </Stack>
    </ET3PageDiv>
  );
});
export default UserAdvanced;
